import { useTranslation } from 'react-i18next';
import KoobLoadingOverlay from '@koob/ui/src/components/KoobLoadingOverlay';
import { ReceiptTypeEnum } from './ReceiptTypeEnum';

export default function ReceiptLoading({ type = ReceiptTypeEnum.TRIP }) {
  const { t } = useTranslation('trips');

  const isBooking = type === ReceiptTypeEnum.BOOKING;
  const title = isBooking
    ? t('receipt.loading.titleBooking')
    : t('receipt.loading.titleTrip');
  const description = isBooking
    ? t('receipt.loading.descriptionBooking')
    : t('receipt.loading.descriptionTrip');

  return <KoobLoadingOverlay title={title} description={description} />;
}
